import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const benefitRows = [['✅ 6 Complete Volumes', '🎁 5 Exclusive Bonuses'], ['💬 200 Reflection Questions', '🔮 Therapeutic Tarot Spreads'], ['📋 Session & Progress Tools', '🌙 Astrology, Grounding & Ethics']];
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/9WAuf1mitPx3dRhsJBtUfS/Mockup_Tarot_(ingles).png';
export function Hero() {
  return <>
      <section className="w-full bg-mist px-4 py-4 text-navy sm:py-6" data-id="element-107" data-mp="127eereur1rdz">
        <div className="mx-auto max-w-5xl text-center" data-id="element-108" data-mp="xbpaiy7sbmbc">
          <motion.span initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="inline-flex rounded-full border border-amber/50 bg-surface px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-amber" data-id="element-109" data-mp="sb1ajn1kvv4z">
            ✦ Stop Performing. Start Transforming. ✦
          </motion.span>
          <h1 className="sr-only" data-id="element-110" data-mp="3j893b0s41pjq">Therapeutic Tarot Guide™</h1>
          <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.1
        }} className="mx-auto mt-4 max-w-2xl text-base font-semibold leading-snug text-navy sm:text-lg" data-id="element-111" data-mp="3o7lrboupx2nw">
            Everything you need to interpret Tarot with clarity and structure meaningful readings
            with confidence.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.15
        }} className="mx-auto mt-5 max-w-3xl text-center" data-id="element-112" data-mp="359j6lm97drvw">
            <p className="text-xs font-bold uppercase tracking-[0.12em] text-amber" data-id="element-113" data-mp="2hinaicxpsaiu">
              📦 EVERYTHING YOU GET INSTANTLY
            </p>
            <div className="mt-2 space-y-1 text-xs font-medium text-slate sm:text-sm" data-id="element-114" data-mp="2ljz2uq7z39uq">
              {benefitRows.map(row => <p key={row.join('-')} className="flex flex-wrap justify-center gap-x-5 gap-y-1" data-id="element-115" data-mp="nbbcixheu94r">
                  {row.map(benefit => <span key={benefit} data-id="element-116" data-mp="id9tgcjzi9ta">{benefit}</span>)}
                </p>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.2
        }} className="mx-auto mt-5 max-w-3xl" data-id="element-117" data-mp="dbasf9bpvozi">
            <img src={mockupUrl} alt="Therapeutic Tarot Guide — 6 volumes and 5 exclusive bonuses with printable session templates, journals and reference charts" width={1536} height={1024} className="mx-auto block h-auto w-full max-w-3xl rounded-3xl object-contain shadow-elevated" data-id="element-118" data-mp="111esx7tlz8ma" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: 0.25
        }} className="mt-5" data-id="element-119" data-mp="1xacfx49qzltr">
            <CTAButton href="#complete-package" pulse size="large" data-id="element-120" data-mp="268og9y0f1xze">
              GET INSTANT ACCESS
            </CTAButton>
            <p className="mx-auto mt-3 max-w-3xl text-xs leading-relaxed text-slate sm:text-sm" data-id="element-121" data-mp="2fzsu2uecvcsn">
              📄 High-Quality PDF <span className="mx-1" data-id="element-122" data-mp="2kydv2w1fm0i5">·</span> 🖨️ Printable Resources{' '}
              <span className="mx-1" data-id="element-123" data-mp="2l0qc96zd86u5">·</span> ⚡ Instant Download <span className="mx-1" data-id="element-124" data-mp="2p1jyzx12nflg">·</span> 🔒
              Secure Payment <span className="mx-1" data-id="element-125" data-mp="2tzboyli5orn0">·</span> 🛡️ 7-day guarantee
            </p>
          </motion.div>
        </div>
      </section>

      <section className="border-y border-amber/40 bg-surface px-4 py-5 text-navy" data-id="element-126" data-mp="unj1bfh9cymy">
        <div className="mx-auto max-w-3xl text-center" data-id="element-127" data-mp="zl12uksy4bkx">
          <p className="text-sm font-bold sm:text-base" data-id="element-128" data-mp="znn8ug06uj11">
            🚀 Launch offer active — All 5 Bonus Guides FREE with purchase · Price increases when
            the timer hits zero
          </p>
          <div className="mx-auto mt-3 h-2 max-w-xl overflow-hidden rounded-full bg-amber/20" data-id="element-129" data-mp="3vjrvoi6lo7v8">
            <div className="h-full w-[78%] rounded-full bg-amber" data-id="element-130" data-mp="e7h93eirhopa" />
          </div>
          <p className="mt-2 text-xs font-medium text-slate" data-id="element-131" data-mp="9b0eq2kyye3r">78% of launch spots already claimed</p>
        </div>
      </section>
    </>;
}